import { GuestLayout } from "../../components/layouts/GuestLayout";
import { Banner } from "./sections/Banner";
import { Counter } from "./sections/Counter";
import { Faqs } from "./sections/Faqs";
import { Footer } from "./sections/Footer";
import { Frame } from "./sections/Frame";
import { Header } from "./sections/HeaderView";

export const Landing = () => {
  return (
    <GuestLayout>
      <Header />
      <Frame />
      <Counter />
      <Faqs />
      <Banner />
      <Footer />
    </GuestLayout>
  );
};
